module.exports = __webpack_public_path__ + "static/media/emptyUserIcon.b97560ed.svg";